import { times } from "lodash";

export default {
    computed: {

    },
    methods: {
      getParseLocation(data){
        var that = this;
        var parseIdc = JSON.parse(data);
        var locationList = [];
        if(parseIdc){
          parseIdc.forEach(x => {
            var rooms = [];
            x.forEach(async (y)=> {
              let arr = [];
              let listParam = await that.$store.getters["location/location"];
              that.makeOjectFindKey(arr, listParam, y);
              if(arr.length != 0){
                var o = {id: y, name: arr[0].locationName, code: arr[0].locationCode}
                rooms.push(o);
              }
            })

            var location = {id: this.uuidv4() ,name:_.map(rooms, x => x.name).join(' > '), checked: false, rooms: rooms, key: _.map(rooms, x => x.code).join('')}
            locationList.push(location);
          });
        }

        return locationList;
      },

      makeOjectFindKey(acc, list, key){
        list.forEach((x)=>{
          if(x.locationCode == key){
            acc.push(x)
          }else{
            this.makeOjectFindKey(acc, x.children, key);
          }
        })
      },

      getStringLocationData(list){
        var location = [];
        list.forEach(x=>{
          location.push(_.map(x.rooms,x=>x.id));
        })
        return location;
      },
      // 자식없는 노드 찾기
      t(list, acc){
        list.forEach(x =>{
          if(x.children.length > 0) {
            this.t(x.children, acc);
          }else{
            acc.push(x)
          }
        })
      },
      /*
      findFlat() {
        var locationAll = this.$store.getters["location/location"];
        var acc = [];
        var endChildrenList = this.t(locationAll, []);

        endChildrenList.forEach(x=>{
          x.
        })
      }
      */
     async findParent(acc, x){
      var location = await this.$store.getters['location/location'];
      var arr = [];
      this.makeOjectFindKey(arr, location, x.parentCode);
      if(arr[0]){
        acc.push(arr[0])
        this.findParent(acc, arr[0])

      }else{
        return acc
      }
     },

      //위치 정보 반환
     async trunkList(idc){
      var list = null;
      if(idc){
        list = await this.makeKeyIdc(idc);
      }else{
        list = await this.makeKey();
      }
      var result = [];

      list.forEach(o => {
        var rooms = [];
        o.forEach(x=>{
          var o = {id: x.locationCode, name: x.locationName, code: x.locationCode, codeValue: x.codeValue}
          rooms.push(o);
        })
        rooms.reverse();
        var location = {id: this.uuidv4() ,name:_.map(rooms, x => x.name).join(' > '), reserved: false, checked: false, rooms: rooms, isLock: _.map(rooms, x => x.codeValue).join('') ? true: false ,key:_.map(rooms, x => x.code).join('')}
        result.push(location);
      })

      return result;
    },
    async makeKey(){
      var that = this;
      var location = await this.$store.getters['location/location'];
      var list = [];
      this.t(location, list);
      var result = [];
      list.forEach((x)=>{
        var arr = [x];
        var y = that.findParent(arr, x);
        result.push(arr);
      });
      return result;
    },
    makeKeyIdc(idc){
      var that = this;
      var location = idc;
      var list = [];
      this.t(location, list);
      var result = [];
      list.forEach((x)=>{
        var arr = [x];
        var y = that.findParent(arr, x);
        result.push(arr);
      });
      return result;
     }
    },
    async location() {
      var result = null;
      if(await this.$store.getters['location/location']){
        result = await this.$store.getters['location/location'];
      }
      return result;
    },

  }
